import React from 'react'

export default function signup() {
    return (
        <h1 className="signup">
            Sign-up
        </h1>
    )
}
